module.exports = __webpack_public_path__ + "assets/img/service-255c3ee7.png";